<template>
  <div id="withdrawSuccess">
    <img class="success_img"
         :src="successImg"
         alt="">
    <div class="success_title">提现成功</div>
    <div class="success_msg">预计3个工作日内到账</div>
    <div class="success_btn"
         @click="backToLastPage">返回</div>
  </div>
</template>

<script>
export default {
  name: 'withdrawSuccess',
  data () {
    return {
      successImg: this.$store.state.ossLink + 'tixian_icon_success.png'
    }
  },
  methods: {
    backToLastPage () {
      this.$router.go(-1)
    },
    wxShare () {
      let self = this
      self.$fly
        .request({
          url: '/component/wechat/login/get/js/config/stat',
          params: {
            url: location.href.split('#')[0]
          }
        })
        .then(res => {
          if (res.success) {
            self.$wx.config({
              debug: false,
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: [
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem'
              ]
            })
            self.$wx.ready(function () {
              // 隐藏分享
              self.$wx.hideAllNonBaseMenuItem()
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  activated () {
    this.wxShare()
  },
  mounted () { }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#withdrawSuccess {
  width: 100%;
}
.success_img {
  margin-top: 250px;
  width: 200px;
  height: 200px;
  margin-left: calc(50% - 100px);
}
.success_title {
  width: 100%;
  margin: 40px auto;
  font-size: 36px;
  text-align: center;
  color: #666666;
}
.success_msg {
  width: 100%;
  margin: 40px auto;
  font-size: 26px;
  color: #999999;
  text-align: center;
}
.success_btn {
  margin-top: 150px;
  width: 258px;
  height: 88px;
  background-color: #ffffff;
  border-radius: 10px;
  margin-left: calc(50% - 129px);
  text-align: center;
  line-height: 88px;
  font-size: 30px;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/views/mine/withdraw/success.vue